import { render, staticRenderFns } from "./RightsView.vue?vue&type=template&id=e62c5836&scoped=true&"
import script from "./RightsView.vue?vue&type=script&lang=js&"
export * from "./RightsView.vue?vue&type=script&lang=js&"
import style0 from "./RightsView.vue?vue&type=style&index=0&id=e62c5836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e62c5836",
  null
  
)

export default component.exports